module.exports = __webpack_public_path__ + "static/media/success_image.f784e133.svg";